// ASCII art templates

export const ASCII = {
	train: `
      ====        ________                ___________
  _D _|  |_______/        \\__I_I_____===__|_________|
   |(_)---  |   H\\________/ |   |        =|___ ___|
   /     |  |   H  |  |     |   |         ||_| |_||
  |      |  |   H  |__--------------------| [___] |
  | ________|___H__/__|_____/[][]~\\_______|       |
  |/ |   |-----------I_____I [][] []  D   |=======|__
__/ =| o |=-~~\\  /~~\\  /~~\\  /~~\\ ____Y___________|__
 |/-=|___|=O=====O=====O=====O   |_____/~\\___/
  \\_/      \\__/  \\__/  \\__/  \\__/      \\_/`,

	doom: `
╔═══════════════════════════════════════════════════════╗
║     ██████╗  ██████╗  ██████╗ ███╗   ███╗            ║
║     ██╔══██╗██╔═══██╗██╔═══██╗████╗ ████║            ║
║     ██║  ██║██║   ██║██║   ██║██╔████╔██║            ║
║     ██║  ██║██║   ██║██║   ██║██║╚██╔╝██║            ║
║     ██████╔╝╚██████╔╝╚██████╔╝██║ ╚═╝ ██║            ║
║     ╚═════╝  ╚═════╝  ╚═════╝ ╚═╝     ╚═╝            ║
║                                                       ║
║              GOD MODE ACTIVATED                       ║
╚═══════════════════════════════════════════════════════╝`,

	rickroll: `
    ███╗   ██╗███████╗██╗   ██╗███████╗██████╗
    ████╗  ██║██╔════╝██║   ██║██╔════╝██╔══██╗
    ██╔██╗ ██║█████╗  ██║   ██║█████╗  ██████╔╝
    ██║╚██╗██║██╔══╝  ╚██╗ ██╔╝██╔══╝  ██╔══██╗
    ██║ ╚████║███████╗ ╚████╔╝ ███████╗██║  ██║
    ╚═╝  ╚═══╝╚══════╝  ╚═══╝  ╚══════╝╚═╝  ╚═╝

     ██████╗  ██████╗ ███╗   ██╗███╗   ██╗ █████╗
    ██╔════╝ ██╔═══██╗████╗  ██║████╗  ██║██╔══██╗
    ██║  ███╗██║   ██║██╔██╗ ██║██╔██╗ ██║███████║
    ██║   ██║██║   ██║██║╚██╗██║██║╚██╗██║██╔══██║
    ╚██████╔╝╚██████╔╝██║ ╚████║██║ ╚████║██║  ██║
     ╚═════╝  ╚═════╝ ╚═╝  ╚═══╝╚═╝  ╚═══╝╚═╝  ╚═╝`,

	nyan: `
+      o     +              o
    +             o     +       +
o          +
    o  +           +        +
+        o     o       +        o
-_-_-_-_-_-_-_,------,      o
_-_-_-_-_-_-_-|   /\\_/\\
-_-_-_-_-_-_-~|__( ^ .^)  +     +
_-_-_-_-_-_-_-""  ""
+      o         o   +       o
    +         +
o        o         o      o     +
    o           +
+      +     o        o      +`
};

export function cowsay(text: string): string {
	const line = '_'.repeat(text.length + 2);
	return `
 ${line}
< ${text} >
 ${'-'.repeat(text.length + 2)}
        \\   ^__^
         \\  (oo)\\_______
            (__)\\       )\\/\\
                ||----w |
                ||     ||`;
}

// Jokes and fortunes
export const JOKES = [
	'Why do programmers prefer dark mode? Because light attracts bugs.',
	'A SQL query walks into a bar, walks up to two tables and asks... "Can I join you?"',
	"Why do Java developers wear glasses? Because they can't C#.",
	"There are only 10 types of people: those who understand binary and those who don't.",
	'Why did the developer go broke? Because he used up all his cache.',
	"How many programmers does it take to change a light bulb? None, that's a hardware problem.",
	'A programmer\'s wife tells him: "Go to the store and get a loaf of bread. If they have eggs, get a dozen." He comes home with 12 loaves of bread.',
	'Why do programmers hate nature? It has too many bugs.',
	'["hip", "hip"] // hooray',
	"!false // It's funny because it's true"
];

export const FORTUNES = [
	'The code you write today will confuse you tomorrow.',
	'A clean codebase is a happy codebase.',
	'Git commit often, push with purpose.',
	'The best error message is the one that never shows up.',
	'Debugging is like being a detective in a crime movie where you are also the murderer.',
	'First, solve the problem. Then, write the code.',
	"Code is like humor. When you have to explain it, it's bad.",
	'The only way to go fast is to go well.',
	'Premature optimization is the root of all evil.',
	'There are two hard things in computer science: cache invalidation, naming things, and off-by-one errors.'
];
